import { api } from "./client";

export type AiSettings = {
  aiCoreIdea: string;
  aiMode: "preview" | "auto";
  configured: boolean;
};

export type AiDraft = {
  id: string;
  threadId: string;
  messageId: string;
  draftBody: string;
  status: "pending" | "approved" | "sent" | "discarded";
  createdAt: string;
  thread: { id: string; subject: string | null } | null;
  message: {
    id: string;
    fromEmail: string;
    snippet: string | null;
    receivedAt: string;
  } | null;
};

export function getAiSettings(): Promise<AiSettings> {
  return api(`/ai/settings`);
}

export function updateAiSettings(
  patch: Partial<Pick<AiSettings, "aiCoreIdea" | "aiMode">>,
): Promise<{ aiCoreIdea: string; aiMode: "preview" | "auto" }> {
  return api(`/ai/settings`, { method: "PATCH", body: patch });
}

export function listDrafts(): Promise<{ drafts: AiDraft[] }> {
  return api(`/ai/drafts`);
}

export function getDraft(id: string): Promise<{ draft: AiDraft }> {
  return api(`/ai/drafts/${id}`);
}

export function generateDraft(
  threadId: string,
  messageId: string,
): Promise<{ draftId: string; body: string }> {
  return api(`/ai/drafts/generate`, {
    method: "POST",
    body: { threadId, messageId },
  });
}

export function editDraft(
  id: string,
  draftBody: string,
): Promise<{ ok: true }> {
  return api(`/ai/drafts/${id}`, { method: "PATCH", body: { draftBody } });
}

export function approveDraft(id: string): Promise<{ ok: true }> {
  return api(`/ai/drafts/${id}/approve`, { method: "POST" });
}

export function discardDraft(id: string): Promise<{ ok: true }> {
  return api(`/ai/drafts/${id}/discard`, { method: "POST" });
}
